import type React from "react"
import { createContext, useContext } from "react"
import { useChatSession, type ChatSessionHook } from "./useChatSession"

const ChatContext = createContext<ChatSessionHook | null>(null)

export const ChatProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const chat = useChatSession()

  return <ChatContext.Provider value={chat}>{children}</ChatContext.Provider>
}

export const useChat = () => {
  const context = useContext(ChatContext)
  if (!context) {
    throw new Error("useChat must be used within a ChatProvider")
  }
  return context
}
